module.exports = __webpack_public_path__ + "static/media/gm.84f125cc.webp";